// AUTO-GENERATED GraphQL Builder for OfferingItem
import * as Builders from '../';
export class OfferingItemBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  offeringId(){ return this.add('offeringId'); }
  name(){ return this.add('name'); }
  mode(){ return this.add('mode'); }
  price(){ return this.add('price'); }
  sortOrder(){ return this.add('sortOrder'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  offering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offering'))return this;
    this.v.add('offering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offering { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  bookingItemSelectionList(b?:(q:Builders.BookingItemSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingItemSelectionList'))return this;
    this.v.add('bookingItemSelectionList');
    const n=new Builders.BookingItemSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingItemSelectionList { ${inner} }`);
    return this;
  }

  itemPhotoList(b?:(q:Builders.ItemPhotoBuilder)=>void){
    if(this.depth>=5||this.v.has('itemPhotoList'))return this;
    this.v.add('itemPhotoList');
    const n=new Builders.ItemPhotoBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`itemPhotoList { ${inner} }`);
    return this;
  }

  packageOptionList(b?:(q:Builders.PackageOptionBuilder)=>void){
    if(this.depth>=5||this.v.has('packageOptionList'))return this;
    this.v.add('packageOptionList');
    const n=new Builders.PackageOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageOptionList { ${inner} }`);
    return this;
  }

  resaleList(b?:(q:Builders.ResaleBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleList'))return this;
    this.v.add('resaleList');
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  resaleTermList(b?:(q:Builders.ResaleTermBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleTermList'))return this;
    this.v.add('resaleTermList');
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }

  reverseBookingItemSelection(b?:(q:Builders.BookingItemSelectionBuilder)=>void){
    const n=new Builders.BookingItemSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingItemSelectionList { ${inner} }`);
    return this;
  }

  reverseItemPhoto(b?:(q:Builders.ItemPhotoBuilder)=>void){
    const n=new Builders.ItemPhotoBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`itemPhotoList { ${inner} }`);
    return this;
  }

  reversePackageOption(b?:(q:Builders.PackageOptionBuilder)=>void){
    const n=new Builders.PackageOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageOptionList { ${inner} }`);
    return this;
  }

  reverseResale(b?:(q:Builders.ResaleBuilder)=>void){
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  reverseResaleTerm(b?:(q:Builders.ResaleTermBuilder)=>void){
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }
}
